import React from "react";
import { useNavigate } from "react-router-dom";

const Banner: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="homeBnr pt-36 lg:pt-48 pb-56 h-[600px] lg:h-[930px] px-5">
      <div className="container mx-auto flex flex-col items-center text-center">
        {/* <h2 className="headingA xl:px-32">
          The definitive ranking of the biggest clubs in English football
        </h2> */}
        <h1 className="headingA xl:px-32">
          The definitive ranking of the biggest clubs in English football
        </h1>
        <h6 className="bannerSmallhdn pb-10 lg:px-48">
          The definitive measurement and ranking of football club greatness
          worldwide. Comprehensive analytics that determine which clubs truly
          dominate the beautiful game.
        </h6>
        
        <button
          className="redButton flex items-center gap-2 uppercase"
          onClick={() => navigate("/league-table")}
        >
          View League Table
        </button>
      </div>
    </section>
  );
};

export default Banner;

